import * as React from "react";
import {Field, getIn} from "formik";
import { IconButton, Tooltip } from "@material-ui/core";

export interface FieldProps {
    autoComplete?: string;
    name: string,
    placeholder?: string,
    label?: any | string,
    id?: string,
    onBlur?: Function,
    cb?: any,
    contentList?: any,
    options?: any,
    onChange?: Function,
    component?: Function,
    values?: any,
    onSelectChange?: Function,
    InputProps?: any,
    helperText?: any,
    InputLabelProps?:any,
    className?: string
    multiline?: Boolean,
    disablePast?:Boolean,
    disableFuture?:Boolean,
    saveFormat?: string,
    disabled?: boolean,
    icon?: boolean,
    onClick?: Function,
    innerRef?: any
    onFocus?: Function,
}

const TextFieldCommon = (props: FieldProps) => {
    const { name, values, className } = props;
    let icon: any = "";
    const data = getIn(values, name)
    let toolTip: string = "";
    if (props.icon) {
        const filedName = `${name}Updated`;
        const updatedVal = values ? values[filedName] : "";
        icon = updatedVal ? <>�</> : <>�</>;
        toolTip = updatedVal ? "has been overriden by Admin." : "– Editing overrides automation";
    }

    return <>
        {props.icon && <>
            <div className={`iconLabel`}>{props.label}
                <Tooltip color="primary" title={`System-Generated Value ${toolTip}`} arrow>
                    <IconButton aria-label="Info"> {icon} </IconButton>
                </Tooltip>
            </div>
        </>}
        <Field
                className={`${className ? className : ""}`}
            value={values ? data : ""}
                {...props}
                fullWidth
        /></>;
};


export default TextFieldCommon;

export type TextFieldCommonFieldProps = FieldProps;